import { Tooltip, makeStyles, Icon } from '@material-ui/core';
import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export interface CustomTooltipProps {
  text: string;
  driverName: string;
}

// Fallback MEDDPICC driver definitions for short codes from FastAPI
const MEDDPICC_DEFINITIONS: Record<string, string> = {
  m: 'The quantifiable business outcomes your solution can influence.',
  e: 'The person with budget authority who can sign off on the purchase decision.',
  d: 'The formal and informal criteria the prospect uses to evaluate and select a solution.',
  d_proc: 'The sequence of steps, approvals, and stakeholders involved before a deal is closed.',
  i: 'The specific business problem or challenge driving the prospect\'s urgency to act.',
  c: 'An internal advocate who believes in your solution and actively influences the buying process on your behalf.',
  comp: 'The alternatives the prospect is considering, including competitors, incumbents and the "do nothing" option.',
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  driverName
}: CustomTooltipProps) => {
  const useStyles = makeStyles({
    active: {
      color: '#0B69FF',
      margin: '0 0 2px 3px',
      fontSize: 17,
      fontFamily: 'Rubik',
      fontWeight: 500,
      textTransform: 'none',
    },
    customTooltip: {
      '& .MuiTooltip-arrow': {
        color: '#0B69FF', // Change to your desired color
      },
      backgroundColor: 'white',
      fontFamily: 'Rubik',
      border: '1px solid #0B69FF',
      color: '#171F46',
      fontWeight: 300,
      fontSize: '13px',
    },
  });

  const classes = useStyles();
  const config = JSON.parse(localStorage.getItem("mappingConfig")||"{}")
  const driverMapping = config.driverMapping
  const driver = driverName?.split('(')[0].trim()
  const driverLower = driver?.toLowerCase()
  // Extract short code before colon, e.g. "I:Identify Pain" -> "i"
  const shortCode = driverLower?.split(':')[0].trim()
  const title = text
    || driverMapping?.find((d:any)=>d?.label == driver || d?.label == driverName || d?.value?.toLowerCase() === shortCode)?.definition
    || (shortCode && MEDDPICC_DEFINITIONS[shortCode])
    || (driverLower && MEDDPICC_DEFINITIONS[driverLower])
  return (
    <Tooltip
      placement="top"
      arrow
      classes={{ tooltip: classes.customTooltip }}
      title={title || 'No Driver Definition Found'}
    >
      <Icon component={InfoOutlinedIcon} className={classes.active} />
    </Tooltip>
  );
};

export default CustomTooltip;
